'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withWindow = require('../helpers/withWindow');

var _withWindow2 = _interopRequireDefault(_withWindow);

var _NewSpotSearch = require('./NewSpotSearch');

var _NewSpotSearch2 = _interopRequireDefault(_NewSpotSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _withWindow2.default)(_NewSpotSearch2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewSpotSearch/index.js
// module id = 305
// module chunks = 0